import { Blackjack } from 'game-logic';
import { GameServices } from '../../services/game-services';
import { assertNever } from 'src/games/common/helper';
import { BlackjackStylesType, BlackjackTranslationsType } from '../../model/blackjack-types';

export class ResultsViewModel {
  public get logicEventQueue$() {
    return this.gameServices.blackjackGameRunner.logicEventQueue$;
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get backgroundColor() {
    return this.gameServices.gameThemeService.getNumericalRGB(
      BlackjackStylesType.BackgroundPrimary,
    );
  }
  public get labelFill() {
    return this.gameServices.gameThemeService.getHexColor(BlackjackStylesType.LabelFill);
  }

  constructor(private gameServices: GameServices) {}

  public resultLabel(result: Blackjack.RoundResult): string {
    const translationService = this.gameServices.gameTranslationService;

    switch (result) {
      case Blackjack.RoundResult.Push:
        return translationService.getTranslation(BlackjackTranslationsType.Push);
      case Blackjack.RoundResult.CroupierWin:
        return translationService.getTranslation(BlackjackTranslationsType.DealerWins);
      case Blackjack.RoundResult.PlayerWin:
        return translationService.getTranslation(BlackjackTranslationsType.Won);
      case Blackjack.RoundResult.PlayerBust:
        return translationService.getTranslation(BlackjackTranslationsType.Bust);
      case Blackjack.RoundResult.PlayerBlackjack:
        return translationService.getTranslation(BlackjackTranslationsType.Blackjack);
      default:
        assertNever(result, 'Invalid result state');
    }
  }
}
